import Vue from "vue";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faTimes,
  faInfoCircle,
  faTrash,
  faExclamationTriangle,
  faChevronLeft,
  faChevronRight,
  faPlusCircle,
  faEdit,
  faCircleNotch,
  faArrowCircleDown,
  faArrowLeft,
  faMoneyCheckAlt
} from "@fortawesome/free-solid-svg-icons";
import {
  faUser,
  faTimesCircle,
  faCheckCircle,
  faCircle
} from "@fortawesome/free-regular-svg-icons";

import {faFacebookSquare} from "@fortawesome/free-brands-svg-icons";

import { faFacebookF, faGoogle } from "@fortawesome/free-brands-svg-icons";
import {
  FontAwesomeIcon,
  FontAwesomeLayers
} from "@fortawesome/vue-fontawesome";

library.add(faArrowLeft, faTimes, faInfoCircle, faTrash, faCircle, faArrowCircleDown, faMoneyCheckAlt);
library.add(faExclamationTriangle, faChevronLeft, faChevronRight);
library.add(faPlusCircle, faEdit, faCircleNotch, faCheckCircle);
library.add(faUser, faTimesCircle, faFacebookF, faGoogle, faFacebookSquare);

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("font-awesome-layers", FontAwesomeLayers);
